module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/underline-1c6786172e13f8c0fc91399a2b613f62.svg";